(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nr-mini-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nr-mini-motion')) {
  customElements.define('nr-mini-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      const status = this.querySelector('[role="status"]');
      const sound = this.querySelector('[data-motion-sound]');
      let soundEnabled = false;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      let manualPaused = false;
      let autoplayRejected = false;
      let pending = false;
      let generation = 0;
      const update = () => {
        button.textContent = video.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        button.setAttribute('aria-pressed', String(!video.paused));
      };
      const pause = () => { generation++; pending = false; video.pause(); update(); };
      const autoAllowed = () => visible && !document.hidden && !manualPaused && !autoplayRejected && !reduced.matches && !navigator.connection?.saveData;
      const play = async (manual = false) => {
        if (pending || !video.paused || document.hidden || (!manual && !autoAllowed())) return;
        const attempt = ++generation;
        pending = true;
        status.textContent = '';
        if (!video.getAttribute('src')) video.src = video.dataset.videoUrl;
        video.muted = !soundEnabled;
        try {
          await video.play();
          if (attempt !== generation || document.hidden || (!manual && !autoAllowed())) video.pause();
        } catch (_) {
          if (attempt === generation) {
            autoplayRejected = !manual;
            if (manual) status.textContent = this.dataset.errorLabel;
          }
        } finally {
          if (attempt === generation) pending = false;
          update();
        }
      };
      button.addEventListener('click', () => {
        if (!video.paused || pending) { manualPaused = true; pause(); return; }
        manualPaused = false;
        autoplayRejected = false;
        play(true);
      }, options);
      sound?.addEventListener('click', () => {
        soundEnabled = !soundEnabled;
        video.muted = !soundEnabled;
        sound.textContent = soundEnabled ? 'Mute sound' : 'Sound on';
        sound.setAttribute('aria-pressed', String(soundEnabled));
        if (video.paused) { manualPaused = false; autoplayRejected = false; play(true); }
      }, options);
      video.addEventListener('play', update, options);
      video.addEventListener('pause', update, options);
      video.addEventListener('ended', update, options);
      video.addEventListener('error', () => { status.textContent = this.dataset.errorLabel; update(); }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); else play(); }, options);
      reduced.addEventListener('change', () => { if (reduced.matches) pause(); else play(); }, options);
      navigator.connection?.addEventListener('change', () => { if (navigator.connection.saveData) pause(); else play(); }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.5;
          if (!visible) pause(); else play();
        }, { threshold: [0, 0.5] });
        this.observer.observe(video);
      }
      this.stop = pause;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.stop?.();
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
